import React, { Component } from 'react';
import { Card, Avatar, message, Input, List, Breadcrumb } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import axios from 'axios';
import Configuration from '../../Configuration';
const { Meta } = Card;
const Search = Input.Search;

class ProfileCars extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.state = {redirect: false, profile: {names: '', status: true}, cars: [], filteredCars: []};
    this.validateToken = this.validateToken.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.getProfile = this.getProfile.bind(this);
    this.getCars = this.getCars.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getProfile();
    this.getCars();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});
    
    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin or manager"))
      this.setState({redirect: true});
  }

  getProfile() {
    const id = this.props.match.params.id;

    axios.get(`${Configuration.apiServer}/api/v1/profiles/${id}`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({profile: resp.data});
    });
  }

  getCars() {
    const id = this.props.match.params.id;

    axios.get(`${Configuration.apiServer}/api/v1/cars/${id}/employee`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({cars: resp.data, filteredCars: resp.data});
    });
  }

  handleStatus(id) {
    axios.put(`${Configuration.apiServer}/api/v1/profiles/${id}/status`, {}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getProfile();
    });
  }

  handleSearch(event) {
    const cars = this.state.cars.filter(car => {
      return car.plates.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1 || car.details.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1
    });

    this.setState({filteredCars: cars});
  }
  
  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // Render component
    return (
      <div>
        <PublicMenu />
        
        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex flex-row flex-start">
            <Breadcrumb>
              <Breadcrumb.Item> <a href="/admin/users">Usuarios</a> </Breadcrumb.Item>
              <Breadcrumb.Item>Autos de {this.state.profile.names}</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <br/>

          <div className="d-flex flex-row flex-wrap justify-content-between">
            <div style={{ width: '30%', padding: '0px 10px' }}>
              <Search placeholder="Buscar..." onChange={this.handleSearch} style={{ width: '100%' }} />

              <br/><br/>

              <Card
                style={{ width: '100%', margin: '0px' }}
              >
                <Meta
                  avatar={<Avatar icon="solution" />}
                  title={this.state.profile.names}
                />
                <p className={`cursor text-${Configuration.getStatus(this.state.profile.status).color}`} onClick={() => { this.handleStatus(this.state.profile.id) }}>{Configuration.getStatus(this.state.profile.status).text}</p>
              </Card>
            </div>

            <div style={{ width: '70%', padding: '0px 10px' }}>
              <List
                itemLayout="horizontal"
                dataSource={this.state.filteredCars}
                renderItem={car => (
                  <List.Item>
                    <List.Item.Meta
                      avatar={<Avatar icon="car" />}
                      title={<span>{car.plates}</span>}
                      description={`Detalles ${car.details}`}
                    />
                  </List.Item>
                )}
              />
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default ProfileCars;



// WEBPACK FOOTER //
// ./src/pages/admin/ProfileCars.js